// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2UqUV","fileBtn":"File_fileBtn__1qF0C","closeBtn":"File_closeBtn__20WtL","fileSelected":"File_fileSelected__5VgJP","disabled":"File_disabled__2DqUO"};